export default "__VITE_PUBLIC_ASSET__ad2ee455__"